import { Card, Col, CardHeader, Container, Row, Alert } from "reactstrap";
import { H5, H2 } from "../../AbstractElements";
// import {   URL_API } from "../../utils/Constant";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useFourListe from "../Fournisseurs/FourApi";
import NouveauBonDiamond from "./addBonDiamond";
import NouveauBonCimaf from "./addBonCimaf";
import NouveauBonLaffrage from "./addBonLaffrage";

const NouveauBon = () => {

    const [selectType, setSelectType] = useState('')
    const [idFournisseur, setIdFournisseur] = useState<number>()
    const [refresh, setRefresh] = useState(false)
    const fournisseur = useFourListe(refresh)

    const selectFournisseur = ({ id, type }: { id: number, type: string }) => {
        setSelectType(type);
        setIdFournisseur(id);
    }

    useEffect(() => {

    }, [idFournisseur, selectType])

    return (
        <div className='page-body'>
            <Breadcrumbs mainTitle="Nouveau" parent="Bons" />
            <Container fluid>

                {
                    fournisseur.length > 0 ? (
                        <>
                            <Row>
                                {
                                    fournisseur.map((item, index) => (
                                        <Col sm={3}>
                                            <Card className={`progress-items pb-0 ${selectType == item.type ? 'bg-light-success' : 'bg-light-info'}`} key={index} onClick={() => selectFournisseur({ id: item.id, type: item.type })}>
                                                <CardHeader className={`pb-4 ${selectType == item.type ? 'bg-light-success' : 'bg-light-info'}`}>
                                                    <H5 className="text-center">
                                                        <span className="fw-bold">{item.name}</span>
                                                    </H5>
                                                </CardHeader>
                                            </Card>
                                        </Col>
                                    ))
                                }
                            </Row>
                            {
                                selectType == 'diamond' ? (

                                    <NouveauBonDiamond id_fournisseur={idFournisseur ?? 0} type={selectType} />

                                ) : selectType == 'diamond_sougueta' ? (

                                    <NouveauBonDiamond id_fournisseur={idFournisseur ?? 0} type={selectType} />

                                ) : selectType == 'cimaf' ? (

                                    <NouveauBonCimaf id_fournisseur={idFournisseur ?? 0} type={selectType} />

                                ) : selectType == 'ciment_de_guinee' ? (

                                    <NouveauBonLaffrage id_fournisseur={idFournisseur ?? 0} type={selectType} />

                                ) : (

                                    <Alert color="light-dark" className="text-center">
                                        <H2>Veuillez Selectionner Un Fournisseur</H2>
                                    </Alert>

                                )
                            }


                        </>

                    ) : (
                        <Alert color="info" className="text-center" timeou>
                            <h5 className="text-white text-uppercase text-white fw-bold">Aucun fournisseur enrégistré, Veuillez enrégistrer les fournisseurs</h5>
                        </Alert>
                    )
                }
            </Container>
        </div >
    )
}

export default NouveauBon;